import React, { useState } from 'react';
import Modal from '../../components/modal/modal';
import axiosInstance from '../../AxiosInstance';
import {
    afterInvoiceActionSuccess,
    rejectFailedResponse,
} from '../bus/afterInvoiceActionSuccess';

export default function ConfirmPayment({ show, setter, invoice }) {
    const [paymentObservations, setPaymentObservations] = useState('');

    const setPayment = () => {
        axiosInstance
            .post('bill_status/' + invoice?.id + '/', {
                payment_observations: paymentObservations,
            })
            .then(rejectFailedResponse)
            .then(() => {
                afterInvoiceActionSuccess(setter);
            });
    };

    return (
        <Modal
            show={show}
            setter={setter}
            onClick={() => setPayment()}
            name={'Confirmar Pago'}
            buttonName={'Confirmar'}
        >
            <div className={'mb-3'}>
                ¿Seguro que deseas confirmar el pago del documento {invoice?.sn}?
            </div>
            <div className={'mb-2'}>
                <label className={'form-label small text-muted mb-1'} htmlFor="confirm-payment-obs">
                    Observaciones (opcional)
                </label>
                <textarea
                    id="confirm-payment-obs"
                    className={'form-control'}
                    rows={4}
                    maxLength={4000}
                    placeholder={'Escribe observaciones sobre el pago si lo deseas…'}
                    value={paymentObservations}
                    onChange={(e) => setPaymentObservations(e.target.value)}
                    style={{ resize: 'vertical', minHeight: '88px' }}
                />
            </div>
        </Modal>
    );
}
